import { employeeTable, employeeList } from "../data/EmployeeManage";
import DepartmentSelect from "@/components/DepartmentSelect.vue";
import RoleSelect from "@/components/RoleSelect.vue";
import AvailableSelect from "@/components/AvailableSelect.vue";
import { post } from "../utils/request";
import { getRoleName } from "../utils/utilApi";

export default {
  data() {
    return {
      showableComp: {
        employeeForm: false,
      },
      disableComp: {
        employeeForm: false,
      },
      searchKeyWord: "",
      t: "",
      currentPage: 1,
      pagesize: 10,
      employeeTable: [],
      employeeList: [],
      employeeForm: {
        name: "",
        userId: "",
        departmentId: "",
        departmentName: "",
        joinTime: "",
        enterTime: "",
        username: "",
        participate: "",
        state: "",
        roleId: []
      }
    }
  },
  components: { DepartmentSelect, RoleSelect, AvailableSelect },
  name: "EmployeeManagement",
  methods: {
    // 切换每页显示数据
    handleSizeChange(val) {
      this.pagesize = val;
      // console.log(`每页 ${val} 条`);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
    },
    // 新增人员信息按钮
    handleAddEmployee() {
      this.employeeForm = {};
      // this.employeeForm = this.$options.data().employeeForm;
      this.showableComp.employeeForm = true;
    },
    formatter(row, column) {
      if (column.property == "participate") {
        return row.participate == 1 ? '是' : '否';
      } else if (column.property == "roleId") {
        return getRoleName(row.roleId);
      } else {
        return row[column.property];
      }
    },
    // 编辑人员信息按钮
    handleEdit(index, row) {
      clearTimeout(this.t);
      this.employeeForm = {};
      this.employeeForm = row;
      this.showableComp.employeeForm = true;
      // 延迟200ms等待子组件初始化后再调用其方法
      this.t = setTimeout(() => {
        this.$refs.departmentSelect.acceptId(row.departmentId);
      }, 200);
    },
    // 取消修改或新增人员信息
    doCancel() {
      this.employeeForm = {};
      this.showableComp.employeeForm = false;
    },
    /**
     * @function POST /employee/search/batch
     * @description 根据地区Id、部门Id查询所有人员信息，此功能一般只有局管理账号或类似于局人事账号之类使用，查找某地区局内所有人员信息
     * @param departmentId 部门Id
     * @param regionId 所属地区Id
     * 
     * @returns employeeList，集合中每项元素的属性如下
     * @returns name姓名, userId用户ID, departmentId部门ID, departmentName部门名称, joinTime参加工作时间, enterTime进入部门时间, username登录用户名, participate是否参加考核, state状态, roleId身份角色Id
     */
    searchUser() {
      let data = {
        departmentId: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentId,
        regionId: JSON.parse(sessionStorage.getItem("regionInfo")).regionId,
      };
      post("/employee/search/batch", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.employeeList = JSON.parse(res.data.data);
        }
      });
    },
    /**
     * @description 添加或修改人员信息
     * @function POST /employee/add
     * 
     * @param name string 姓名
     * @param departmentId int 部门ID
     * @param joinTime YYYY-MM-DD 加入工作时间
     * @param enterTime YYYY-MM-DD 进入部门时间
     * @param username string 登录用户名
     * @param participate int 是否参加考核，1是0否
     * @param state string 状态
     * @param roleId int[] 角色Id
     * 
     * @returns userId的生成userId, departmentName部门名称
     */
    addEmployee() {
      if (!(this.employeeForm.roleId instanceof Array)) {
        let roleArr = [];
        roleArr.push(this.employeeForm.roleId);
        this.employeeForm.roleId = roleArr;
      }
      post("/employee/add", JSON.stringify(this.employeeForm)).then(res => {
        if (res.code == 200) {
          this.employeeForm.userId = JSON.parse(res.data.data).userId;
          this.employeeForm.departmentName = JSON.parse(res.data.data).departmentName;
          this.employeeList.push(JSON.parse(JSON.stringify(this.employeeForm)));
          this.showableComp.employeeForm = false;
          // 添加人员信息后将暂存的清空
          sessionStorage.setItem("employeeManage", "");
          // 初始化组件
          // this.$refs.departmentSelect.initComp("", "");
        }
      })
    },
    /**
     * @description 修改人员信息
     * @function POST /employee/save
     * 
     * @param userId int 用户Id
     * @param name string 姓名
     * @param departmentId int 部门ID
     * @param joinTime YYYY-MM-DD 加入工作时间
     * @param enterTime YYYY-MM-DD 进入部门时间
     * @param username string 登录用户名
     * @param participate int 是否参加考核，1是0否
     * @param state string 状态
     * @param roleId int 角色Id
     * 
     */
    saveEmployee() {
      post("/employee/save", JSON.stringify(this.employeeForm)).then(res => {
        if (res.code == 200) {
          // this.employeeForm.departmentName = JSON.parse(res.data.departmentName);
          this.showableComp.employeeForm = false;
          sessionStorage.setItem("employeeManage", "");
        }
      })
    },
    /**
     * @description 确认删除
     * @function POST /employee/delete
     * 
     * @param userId int 被删除用户Id
     */
    doDelete(index, row) {
      let data = {
        userId: row.userId,
      };
      post("/employee/delete", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < this.employeeList.length; i++) {
            if (row.userId == this.employeeList[i].userId) {
              this.employeeList.splice(i, 1);
              break;
            }
          }
          // this.filteredData.splice(index, 1);
          // 迫使重新查询
          sessionStorage.setItem("employeeManage", "");
        }
      });
    },
    doSubmit() {
      if (Object.prototype.hasOwnProperty.call(this.employeeForm, "userId")) {
        this.saveEmployee();
      } else {
        this.addEmployee();
      }
      this.showableComp.employeeForm = false;
    },
    handleReset(index, row) {
      post("/password/reset", JSON.stringify({ userId: row.userId })).then((res) => {

      });
    }
  },
  created() {
    this.searchUser();
    this.employeeList = employeeList;
    this.employeeTable = employeeTable;
  },
  computed: {
    filteredData() {
      return this.employeeList.filter(data => !this.searchKeyWord || data.name.toLowerCase().includes(this.searchKeyWord.toLowerCase()) || data.departmentName.toLowerCase().includes(this.searchKeyWord.toLowerCase()))
    }
  },
  watch: {
    "showableComp.employeeForm"() {
      if (this.showableComp.employeeForm == false) {
        this.$refs.departmentSelect.initComp("", "");
      }
    }
  }
}